import {
  Breadcrumbs,
  Button,
  IconButton,
  Link,
  ListItem,
  ListItemIcon,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  withWidth,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import CancelIcon from "@material-ui/icons/Cancel";
import ChatIcon from "@material-ui/icons/Chat";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import EditIcon from "@material-ui/icons/Edit";
import NotificationsIcon from "@material-ui/icons/Notifications";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import SortableTable from "../../../Components/SortableTable";
import Title from "../../../Components/Title";

import { Clear } from "@material-ui/icons";
import { Rating } from "@material-ui/lab";
import NoteSection from "../../../Components/NoteSection";
import {
  ECABIN,
  USER_GROUPS,
  formatClientInfoString,
  formatTimeWithTZOffset,
  getToken,
  getUser,
  getWarehouses,
  requestErrorHandler,
  shipmentStatus,
  shippingMethods,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";
import DetailTabs from "../../DeviceDetails/DetailTabs";
const server = EnvSettings.server;

function Contact(props) {
  const { id } = props.computedMatch.params;
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [newCompany, setNewCompany] = useState();
  const [orig, setOrig] = useState();
  const [editCompanyName, setEditCompanyName] = useState(false);
  const [txtRef, setTxtRef] = useState("sdfasf");
  const [warehouseLocation, setWarehouseLocation] = useState();
  useEffect(() => {
    getWarehouses(setWarehouseLocation, dispatch);
  }, [dispatch]);

  const getContact = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        companyId: id,
      }),
    };
    fetch(server + "/get_shipping_companies", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setContact(result.company);
          setOrig(result.company);
        }
      });
  };

  const submitEditCompanyName = () => {
    if (!id) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactData: {
          ...contact,
        },
      }),
    };
    fetch(server + "/edit_shipping_company", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  const editShippingCompany = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactData: {
          ...contact,
        },
      }),
    };
    fetch(server + "/edit_shipping_company", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  const getEtaAccuracy = (contact) => {
    var x = Math.round(contact.etaAccuracy[contact.etaAccuracy.length - 1]);
    return (
      x +
      (x > 0 ? " " + t("shipments.daysAfter") : " " + t("shipments.daysBefore"))
    );
  };

  useEffect(() => {
    if (id) {
      getContact();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return contact && orig ? (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href={"/cpanel/shipments"}>
            {t("shipments.header")}
          </Link>
          <Link color="inherit" href={"/cpanel/shipments/companies"}>
            {t("shipments.shippingCompanies")}
          </Link>
          <Typography color="textPrimary">{orig.name}</Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Title
                style={
                  editCompanyName ? { textDecoration: "line-through" } : {}
                }
              >
                {orig.name}{" "}
                <IconButton
                  onClick={() => {
                    if (editCompanyName) {
                      setNewCompany();
                    }
                    setEditCompanyName(!editCompanyName);
                  }}
                >
                  {!editCompanyName ? <EditIcon /> : <CancelIcon />}
                </IconButton>
              </Title>
              {editCompanyName ? (
                <TextField
                  variant="outlined"
                  fullWidth
                  label={t("contactInfo.companyName")}
                  inputProps={{ maxLength: 255 }}
                  defaultValue={orig.name}
                  onChange={(e) => {
                    setContact({
                      ...contact,
                      name: e.target.value,
                    });
                  }}
                />
              ) : null}
              {editCompanyName && newCompany ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={submitEditCompanyName}
                >
                  {t("submit")}
                </Button>
              ) : null}
            </Grid>
            <Grid item sm={3} xs={12}>
              <Title>{t("shipments.services")}</Title>
              <TextField
                key={txtRef}
                label={t("shipments.services")}
                variant="outlined"
                select
                fullWidth
                onChange={(e) => {
                  if (
                    contact.services &&
                    contact.services.find((v) => v === e.target.value)
                  ) {
                    return;
                  }
                  setContact({
                    ...contact,
                    services: [
                      ...(contact.services ? contact.services : []),
                      e.target.value,
                    ],
                  });
                  setTxtRef(Date.now());
                }}
              >
                {shippingMethods.map((m, i) => (
                  <MenuItem key={i} value={m.value}>
                    {t("shippingMethods." + m.value)}
                  </MenuItem>
                ))}
              </TextField>
              {contact.services
                ? [
                    ...(contact && contact.services ? contact.services : []),
                  ].map((m, i) => (
                    <ListItem
                      button
                      key={i}
                      onClick={() => {
                        setContact({
                          ...contact,
                          services: contact.services.filter((f) => f !== m),
                        });
                      }}
                      style={{ position: "relative" }}
                    >
                      {t("shippingMethods." + m)}
                      <ListItemIcon style={{ position: "absolute", right: 0 }}>
                        <Clear />
                      </ListItemIcon>
                    </ListItem>
                  ))
                : null}
              <Button
                onClick={editShippingCompany}
                variant="contained"
                color="primary"
                disabled={JSON.stringify(orig) === JSON.stringify(contact)}
              >
                {t("save")}
              </Button>
            </Grid>
            <Grid item sm={3} xs={12}>
              <Title>{t("shipments.etaAccuracy")}</Title>
              {contact && contact.etaAccuracy ? getEtaAccuracy(contact) : null}
            </Grid>
            <Grid item sm={3} xs={12}>
              <Title>{t("shipments.rating")}</Title>
              {contact && contact.Shipments ? (
                <Rating
                  value={
                    contact.rating
                      ? contact.rating[contact.rating.length - 1]
                      : 0
                  }
                  precision={0.1}
                  readOnly
                ></Rating>
              ) : null}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <DetailTabs
          activeTabs={[
            {
              permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
              label: (
                <>
                  <DirectionsBoatIcon /> {t("shipments.header")}
                </>
              ),
              content: (
                <SortableTable
                  downloadButton={true}
                  header={t("shipments.header")}
                  tableLayout={"fixed"}
                  headCells={[
                    {
                      id: "Notes",
                      label: "",
                      width: 32,
                      hideFromCsv: true,
                    },
                    {
                      id: "EmailListResupplyOrders",
                      label: "",
                      width: 32,
                      hideFromCsv: true,
                    },
                    {
                      id: "updatedAt",
                      numeric: false,
                      disablePadding: false,
                      label: t("updatedAt"),
                    },
                    {
                      id: "createdAt",
                      numeric: false,
                      disablePadding: false,
                      label: t("createdAt"),
                    },
                    {
                      id: "number",
                      numeric: false,
                      disablePadding: false,
                      label: t("shipments.number"),
                    },
                    {
                      id: "externalRef",
                      numeric: false,
                      disablePadding: false,
                      label: t("shipments.externalRef"),
                    },
                    {
                      id: "User.fullName",
                      numeric: false,
                      disablePadding: false,
                      label: t("createdBy"),
                    },

                    {
                      id: "status",
                      numeric: false,
                      disablePadding: false,
                      label: t("shipments.status"),
                    },
                    {
                      id: "eta",
                      numeric: false,
                      disablePadding: false,
                      label: "ETA",
                    },
                    {
                      id: "shippingInfo",
                      numeric: false,
                      disablePadding: false,
                      label: t("orders.shippingInfo"),
                    },
                    {
                      id: "genericDevices",
                      numeric: false,
                      disablePadding: false,
                      label: t("items"),
                    },
                    {
                      id: "Order",
                      numeric: false,
                      disablePadding: false,
                      label: t("shipments.partOfOrder"),
                    },
                  ]}
                  // disablePagination: true,
                  defaultSortRow={"updatedAt"}
                  handleRowClick={() => {}}
                  getRowStyle={(data) => {
                    var obj = { cursor: "pointer" };
                    var p = shipmentStatus.find((f) => data.status === f.value);
                    if (p && p.color) {
                      return { ...obj, backgroundColor: p.color };
                    }
                    return obj;
                  }}
                  specialDataFormatting={[
                    {
                      id: "Notes",
                      format: (data) => {
                        if (data.find((f) => f.User)) {
                          return (
                            <Tooltip title={t("activeComments")}>
                              <ChatIcon
                                color="primary"
                                style={{ fontSize: 20 }}
                              />
                            </Tooltip>
                          );
                        }
                        return "";
                      },
                    },

                    {
                      id: "EmailListShipments",
                      format: (data, d, dd) => {
                        if (
                          (data &&
                            data.find(
                              (f) =>
                                f &&
                                f.EmailList?.EmailListUsers.find(
                                  (u) => u.User.id === getUser().userId
                                )
                            )) ||
                          dd.UserId === getUser().userId
                        ) {
                          return (
                            <Tooltip title={t("tagged")}>
                              <NotificationsIcon
                                color="primary"
                                style={{ fontSize: 20 }}
                              />
                            </Tooltip>
                          );
                        }
                        return "";
                      },
                    },
                    {
                      id: "updatedAt",
                      format: (data, d, dd) => {
                        if (dd.Notes && dd.Notes.length) {
                          const max = dd.Notes.reduce((prev, current) =>
                            prev && prev.id > current.id ? prev : current
                          );

                          return formatTimeWithTZOffset(max.updatedAt, ECABIN);
                        }
                        return formatTimeWithTZOffset(data, ECABIN);
                      },
                    },

                    {
                      id: "createdAt",
                      format: (data) => {
                        return formatTimeWithTZOffset(data, ECABIN);
                      },
                    },
                    {
                      id: "genericDevices",
                      formatReturnsElement: true,
                      format: (data) => {
                        var x;
                        if (data && data.length > 1) {
                          x = 0;
                          data.forEach((d) => (x = x + d.count));
                          return t("count") + ":" + x;
                        }
                        var a = "";
                        data.forEach((v) => (a = v.count + " x " + v.name));
                        return a;
                      },
                    },
                    {
                      id: "status",
                      format: (data) => {
                        return t(
                          "shipmentStates." +
                            shipmentStatus.find((o) => o.value === data).value
                        );
                      },
                    },
                    {
                      id: "shippingInfo",
                      format: (data, d, dd) => {
                        if (!dd.Order && !dd.ResupplyOrder) {
                          if (dd.shipmentDirection === "outward") {
                            return formatClientInfoString(data, [
                              "companyName",
                              "contactName",
                              "location",
                            ]);
                          } else if (
                            dd.shipmentDirection === "inward" ||
                            dd.shipmentDirection === "between"
                          ) {
                            return warehouseLocation?.find(
                              (f) =>
                                formatClientInfoString(data, [
                                  "companyName",
                                ]) === f.value
                            )?.label;
                          }
                          return "";
                        }
                        return dd.Order
                          ? formatClientInfoString(data, [
                              "companyName",
                              "contactName",
                              "location",
                            ])
                          : dd.ResupplyOrder
                          ? warehouseLocation?.find(
                              (f) =>
                                formatClientInfoString(data, [
                                  "companyName",
                                ]) === f.value
                            )?.label
                          : "";
                      },
                    },
                    {
                      id: "Order",
                      format: (data, d, dd) => {
                        if (dd.Order) {
                          return "Order " + dd.Order.number;
                        } else if (dd.ResupplyOrder) {
                          return "Resupply " + dd.ResupplyOrder.number;
                        }
                        return "";
                      },
                    },
                  ]}
                  // handleScrollClick: showDeviceNewTab,
                  tableData={contact.Shipments}
                  rowsPerPage={50}
                />
              ),
            },
            {
              permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
              label: (
                <>
                  <ChatIcon />
                  {t("notes")}
                </>
              ),
              content: (
                <NoteSection
                  parent={{ ShippingCompanyId: id }}
                  notes={contact.Notes}
                  reload={() => {
                    window.location.reload();
                  }}
                  noPaper={true}
                />
              ),
            },
          ]}
        />
      </Grid>
    </Grid>
  ) : null;
}

export default withWidth()(Contact);
